<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span>Cập nhật Hướng dẫn sử dụng</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="6">
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <div>
                    <h4>Hướng dẫn sử dụng (Tiếng Việt)</h4>
                  </div>
                </div>
                <el-upload
                  :auto-upload="false"
                  list-type="text"
                  action
                  drag
                  :limit="mData.fileUploadOption.HDSD_VI.limit"
                  :accept="mData.fileUploadOption.HDSD_VI.accept"
                  :on-preview="handlePreview"
                  :on-remove="() => handleRemove('HDSD_VI')"
                  :on-change="
                    (file, fileList) => handleChange(file, fileList, 'HDSD_VI')
                  "
                  :on-exceed="()=>handlExceed('HDSD_VI')"
                  :file-list="mData.fileUploadOption.HDSD_VI.fileList"
                  :class="[
                    mData.fileUploadOption.HDSD_VI.fileList.length > 0
                      ? 'disable-upload drag-file  text-center'
                      : 'drag-file text-center',
                  ]"
                >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">
                    Kéo file vào đây hoặc <em>click để upload</em>
                  </div>
                  <div class="el-upload__tip text-left" slot="tip">
                    "Chú ý: Định dạng file hỗ trợ pdf"
                  </div>
                </el-upload>
              </el-card>
            </b-col>
            <b-col md="6">
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <h4>Hướng dẫn sử dụng (Tiếng Anh)</h4>
                </div>
                <el-upload
                  :auto-upload="false"
                  list-type="text"
                  action
                  drag
                  :limit="mData.fileUploadOption.HDSD_EN.limit"
                  :accept="mData.fileUploadOption.HDSD_EN.accept"
                  :on-preview="handlePreview"
                  :on-remove="() => handleRemove('HDSD_EN')"
                  :on-change="
                    (file, fileList) => handleChange(file, fileList, 'HDSD_EN')
                  "
                  :on-exceed="()=>handlExceed('HDSD_EN')"
                  :file-list="mData.fileUploadOption.HDSD_EN.fileList"
                  :class="[
                    mData.fileUploadOption.HDSD_EN.fileList.length > 0
                      ? 'disable-upload drag-file  text-center'
                      : 'drag-file text-center',
                  ]"
                >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">
                    Kéo file vào đây hoặc <em>click để upload</em>
                  </div>
                  <div class="el-upload__tip text-left" slot="tip">
                    "Chú ý: Định dạng file hỗ trợ pdf"
                  </div>
                </el-upload>
              </el-card>
            </b-col>
          </b-row>
        </el-form>
      </div>
    </div>
    <div class="card">
      <div class="card-header">
        <span>Cập nhật cẩm nang sức khỏe</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <!-- Hướng dẫn tạm thời người nhiễm Covid - Theo dõi sức khỏe tại nhà 1 -->
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
        >
          <b-row>
            <b-col md="6">
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <div>
                    <h4>
                      Hướng dẫn tạm thời người nhiễm Covid - Theo dõi sức khỏe
                      tại nhà 1 (Tiếng Việt)
                    </h4>
                  </div>
                </div>
                <el-upload
                  :auto-upload="false"
                  list-type="text"
                  action
                  drag
                  :limit="mData.fileUploadOption.TDSKTN1_VI.limit"
                  :accept="mData.fileUploadOption.TDSKTN1_VI.accept"
                  :on-preview="handlePreview"
                  :on-remove="() => handleRemove('TDSKTN1_VI')"
                  :on-change="
                    (file, fileList) =>
                      handleChange(file, fileList, 'TDSKTN1_VI')
                  "
                  :on-exceed="()=>handlExceed('TDSKTN1_VI')"
                  :file-list="mData.fileUploadOption.TDSKTN1_VI.fileList"
                  :class="[
                    mData.fileUploadOption.TDSKTN1_VI.fileList.length > 0
                      ? 'disable-upload drag-file  text-center'
                      : 'drag-file text-center',
                  ]"
                >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">
                    Kéo file vào đây hoặc <em>click để upload</em>
                  </div>
                  <div class="el-upload__tip text-left" slot="tip">
                    "Chú ý: Định dạng file hỗ trợ pdf"
                  </div>
                </el-upload>
              </el-card>
            </b-col>
            <b-col md="6">
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <h4>
                    Hướng dẫn tạm thời người nhiễm Covid - Theo dõi sức khỏe tại
                    nhà 1 (Tiếng Anh)
                  </h4>
                </div>
                <el-upload
                  :auto-upload="false"
                  list-type="text"
                  action
                  drag
                  :limit="mData.fileUploadOption.TDSKTN1_EN.limit"
                  :accept="mData.fileUploadOption.TDSKTN1_EN.accept"
                  :on-preview="handlePreview"
                  :on-remove="() => handleRemove('TDSKTN1_EN')"
                  :on-change="
                    (file, fileList) =>
                      handleChange(file, fileList, 'TDSKTN1_EN')
                  "
                  :on-exceed="()=>handlExceed('TDSKTN1_EN')"
                  :file-list="mData.fileUploadOption.TDSKTN1_EN.fileList"
                  :class="[
                    mData.fileUploadOption.TDSKTN1_EN.fileList.length > 0
                      ? 'disable-upload drag-file  text-center'
                      : 'drag-file text-center',
                  ]"
                >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">
                    Kéo file vào đây hoặc <em>click để upload</em>
                  </div>
                  <div class="el-upload__tip text-left" slot="tip">
                    "Chú ý: Định dạng file hỗ trợ pdf"
                  </div>
                </el-upload>
              </el-card>
            </b-col>
          </b-row>
        </el-form>
        <!-- Hướng dẫn tạm thời người nhiễm Covid - Theo dõi sức khỏe tại nhà 2 -->
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="6">
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <div>
                    <h4>
                      Hướng dẫn tạm thời người nhiễm Covid - Theo dõi sức khỏe
                      tại nhà 2 (Tiếng Việt)
                    </h4>
                  </div>
                </div>
                <el-upload
                  :auto-upload="false"
                  list-type="text"
                  action
                  drag
                  :limit="mData.fileUploadOption.TDSKTN2_VI.limit"
                  :accept="mData.fileUploadOption.TDSKTN2_VI.accept"
                  :on-preview="handlePreview"
                  :on-remove="() => handleRemove('TDSKTN2_VI')"
                  :on-change="
                    (file, fileList) =>
                      handleChange(file, fileList, 'TDSKTN2_VI')
                  "
                  :on-exceed="()=>handlExceed('TDSKTN2_VI')"
                  :file-list="mData.fileUploadOption.TDSKTN2_VI.fileList"
                  :class="[
                    mData.fileUploadOption.TDSKTN2_VI.fileList.length > 0
                      ? 'disable-upload drag-file  text-center'
                      : 'drag-file text-center',
                  ]"
                >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">
                    Kéo file vào đây hoặc <em>click để upload</em>
                  </div>
                  <div class="el-upload__tip text-left" slot="tip">
                    "Chú ý: Định dạng file hỗ trợ pdf"
                  </div>
                </el-upload>
              </el-card>
            </b-col>
            <b-col md="6">
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <h4>
                    Hướng dẫn tạm thời người nhiễm Covid - Theo dõi sức khỏe tại
                    nhà 2 (Tiếng Anh)
                  </h4>
                </div>
                <el-upload
                  :auto-upload="false"
                  list-type="text"
                  action
                  drag
                  :limit="mData.fileUploadOption.TDSKTN2_EN.limit"
                  :accept="mData.fileUploadOption.TDSKTN2_EN.accept"
                  :on-preview="handlePreview"
                  :on-remove="() => handleRemove('TDSKTN2_EN')"
                  :on-change="
                    (file, fileList) =>
                      handleChange(file, fileList, 'TDSKTN2_EN')
                  "
                  :on-exceed="()=>handlExceed('TDSKTN2_EN')"
                  :file-list="mData.fileUploadOption.TDSKTN2_EN.fileList"
                  :class="[
                    mData.fileUploadOption.TDSKTN2_EN.fileList.length > 0
                      ? 'disable-upload drag-file  text-center'
                      : 'drag-file text-center',
                  ]"
                >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">
                    Kéo file vào đây hoặc <em>click để upload</em>
                  </div>
                  <div class="el-upload__tip text-left" slot="tip">
                    "Chú ý: Định dạng file hỗ trợ pdf"
                  </div>
                </el-upload>
              </el-card>
            </b-col>
          </b-row>
        </el-form>
        <!-- Hướng dẫn tạm thời quản lý người nhiễm Covid tại nhà -->
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="6">
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <div>
                    <h4>
                      Hướng dẫn tạm thời quản lý người nhiễm Covid tại nhà
                      (Tiếng Việt)
                    </h4>
                  </div>
                </div>
                <el-upload
                  :auto-upload="false"
                  list-type="text"
                  action
                  drag
                  :limit="mData.fileUploadOption.QLNNCOVID_VI.limit"
                  :accept="mData.fileUploadOption.QLNNCOVID_VI.accept"
                  :on-preview="handlePreview"
                  :on-remove="() => handleRemove('QLNNCOVID_VI')"
                  :on-change="
                    (file, fileList) =>
                      handleChange(file, fileList, 'QLNNCOVID_VI')
                  "
                  :on-exceed="()=>handlExceed('QLNNCOVID_VI')"
                  :file-list="mData.fileUploadOption.QLNNCOVID_VI.fileList"
                  :class="[
                    mData.fileUploadOption.QLNNCOVID_VI.fileList.length > 0
                      ? 'disable-upload drag-file  text-center'
                      : 'drag-file text-center',
                  ]"
                >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">
                    Kéo file vào đây hoặc <em>click để upload</em>
                  </div>
                  <div class="el-upload__tip text-left" slot="tip">
                    "Chú ý: Định dạng file hỗ trợ pdf"
                  </div>
                </el-upload>
              </el-card>
            </b-col>
            <b-col md="6">
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <h4>
                    Hướng dẫn tạm thời quản lý người nhiễm Covid tại nhà (Tiếng
                    Anh)
                  </h4>
                </div>
                <el-upload
                  :auto-upload="false"
                  list-type="text"
                  action
                  drag
                  :limit="mData.fileUploadOption.QLNNCOVID_EN.limit"
                  :accept="mData.fileUploadOption.QLNNCOVID_EN.accept"
                  :on-preview="handlePreview"
                  :on-remove="() => handleRemove('QLNNCOVID_EN')"
                  :on-change="
                    (file, fileList) =>
                      handleChange(file, fileList, 'QLNNCOVID_EN')
                  "
                  :on-exceed="()=>handlExceed('QLNNCOVID_EN')"
                  :file-list="mData.fileUploadOption.QLNNCOVID_EN.fileList"
                  :class="[
                    mData.fileUploadOption.QLNNCOVID_EN.fileList.length > 0
                      ? 'disable-upload drag-file  text-center'
                      : 'drag-file text-center',
                  ]"
                >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">
                    Kéo file vào đây hoặc <em>click để upload</em>
                  </div>
                  <div class="el-upload__tip text-left" slot="tip">
                    "Chú ý: Định dạng file hỗ trợ pdf"
                  </div>
                </el-upload>
              </el-card>
            </b-col>
          </b-row>
        </el-form>
        <!-- Hướng dẫn tạm thời quản lý người nhiễm Covid - Danh mục các bệnh nền -->
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row style="magin-bottom:20">
            <b-col md="6">
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <div>
                    <h4>
                      Hướng dẫn tạm thời quản lý người nhiễm Covid - Danh mục
                      các bệnh nền (Tiếng Việt)
                    </h4>
                  </div>
                </div>
                <el-upload
                  :auto-upload="false"
                  list-type="text"
                  action
                  drag
                  :limit="mData.fileUploadOption.DMBN_VI.limit"
                  :accept="mData.fileUploadOption.DMBN_VI.accept"
                  :on-preview="handlePreview"
                  :on-remove="() => handleRemove('DMBN_VI')"
                  :on-change="
                    (file, fileList) => handleChange(file, fileList, 'DMBN_VI')
                  "
                  :on-exceed="()=>handlExceed('DMBN_VI')"
                  :file-list="mData.fileUploadOption.DMBN_VI.fileList"
                  :class="[
                    mData.fileUploadOption.DMBN_VI.fileList.length > 0
                      ? 'disable-upload drag-file  text-center'
                      : 'drag-file text-center',
                  ]"
                >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">
                    Kéo file vào đây hoặc <em>click để upload</em>
                  </div>
                  <div class="el-upload__tip text-left" slot="tip">
                    "Chú ý: Định dạng file hỗ trợ pdf"
                  </div>
                </el-upload>
              </el-card>
            </b-col>
            <b-col md="6">
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <h4>
                    Hướng dẫn tạm thời quản lý người nhiễm Covid - Danh mục các
                    bệnh nền (Tiếng Anh)
                  </h4>
                </div>
                <el-upload
                  :auto-upload="false"
                  list-type="text"
                  action
                  drag
                  :limit="mData.fileUploadOption.DMBN_EN.limit"
                  :accept="mData.fileUploadOption.DMBN_EN.accept"
                  :on-preview="handlePreview"
                  :on-remove="() => handleRemove('DMBN_EN')"
                  :on-change="
                    (file, fileList) => handleChange(file, fileList, 'DMBN_EN')
                  "
                  :on-exceed="()=>handlExceed('DMBN_EN')"
                  :file-list="mData.fileUploadOption.DMBN_EN.fileList"
                  :class="[
                    mData.fileUploadOption.DMBN_EN.fileList.length > 0
                      ? 'disable-upload drag-file  text-center'
                      : 'drag-file text-center',
                  ]"
                >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">
                    Kéo file vào đây hoặc <em>click để upload</em>
                  </div>
                  <div class="el-upload__tip text-left" slot="tip">
                    "Chú ý: Định dạng file hỗ trợ pdf"
                  </div>
                </el-upload>
              </el-card>
            </b-col>
          </b-row>
        </el-form>
        <!-- Chăm sóc sức khỏe mùa Covid -->
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
          style="margin-bottom:20"
        >
          <b-row>
            <b-col md="6">
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <div>
                    <h4>Chăm sóc sức khỏe mùa Covid (Tiếng Việt)</h4>
                  </div>
                </div>
                <el-upload
                  :auto-upload="false"
                  list-type="text"
                  action
                  drag
                  :limit="mData.fileUploadOption.CSSK_VI.limit"
                  :accept="mData.fileUploadOption.CSSK_VI.accept"
                  :on-preview="handlePreview"
                  :on-remove="() => handleRemove('CSSK_VI')"
                  :on-change="
                    (file, fileList) => handleChange(file, fileList, 'CSSK_VI')
                  "
                  :on-exceed="()=>handlExceed('CSSK_VI')"
                  :file-list="mData.fileUploadOption.CSSK_VI.fileList"
                  :class="[
                    mData.fileUploadOption.CSSK_VI.fileList.length > 0
                      ? 'disable-upload drag-file  text-center'
                      : 'drag-file text-center',
                  ]"
                >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">
                    Kéo file vào đây hoặc <em>click để upload</em>
                  </div>
                  <div class="el-upload__tip text-left" slot="tip">
                    "Chú ý: Định dạng file hỗ trợ pdf"
                  </div>
                </el-upload>
              </el-card>
            </b-col>
            <b-col md="6">
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <h4>Chăm sóc sức khỏe mùa Covid (Tiếng Anh)</h4>
                </div>
                <el-upload
                  :auto-upload="false"
                  list-type="text"
                  action
                  drag
                  :limit="mData.fileUploadOption.CSSK_EN.limit"
                  :accept="mData.fileUploadOption.CSSK_EN.accept"
                  :on-preview="handlePreview"
                  :on-remove="() => handleRemove('CSSK_EN')"
                  :on-change="
                    (file, fileList) => handleChange(file, fileList, 'CSSK_EN')
                  "
                  :on-exceed="()=>handlExceed('CSSK_EN')"
                  :file-list="mData.fileUploadOption.CSSK_EN.fileList"
                  :class="[
                    mData.fileUploadOption.CSSK_EN.fileList.length > 0
                      ? 'disable-upload drag-file  text-center'
                      : 'drag-file text-center',
                  ]"
                >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">
                    Kéo file vào đây hoặc <em>click để upload</em>
                  </div>
                  <div class="el-upload__tip text-left" slot="tip">
                    "Chú ý: Định dạng file hỗ trợ pdf"
                  </div>
                </el-upload>
              </el-card>
            </b-col>
          </b-row>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import mushroom from "../../../service/mushroom.api.def";
export default {
  // HDSD_VI : Hướng dẫn sử dụng (Tiếng Việt)
  // HDSD_EN : Hướng dẫn sử dụng (Tiếng Anh)
  // TDSKTN1_VI : Hướng dẫn tạm thời người nhiễm Covid - Theo dõi sức khỏe tại nhà 1 (Tiếng Việt)
  // TDSKTN1_EN : Hướng dẫn tạm thời người nhiễm Covid - Theo dõi sức khỏe tại nhà 1 (Tiếng Anh)
  // TDSKTN2_VI : Hướng dẫn tạm thời người nhiễm Covid - Theo dõi sức khỏe tại nhà 2 (Tiếng Việt)
  // TDSKTN2_EN : Hướng dẫn tạm thời người nhiễm Covid - Theo dõi sức khỏe tại nhà 2 (Tiếng Anh)
  // QLNNCOVID_VI : Hướng dẫn tạm thời quản lý người nhiễm Covid tại nhà (Tiếng Việt)
  // QLNNCOVID_EN : Hướng dẫn tạm thời quản lý người nhiễm Covid tại nhà (Tiếng Anh)
  // DMBN_VI : Hướng dẫn tạm thời quản lý người nhiễm Covid - Danh mục các bệnh nền (Tiếng Việt)
  // DMBN_EN : Hướng dẫn tạm thời quản lý người nhiễm Covid - Danh mục các bệnh nền (Tiếng Anh)
  // CSSK_VI : Chăm sóc sức khỏe mùa Covid (Tiếng Việt)
  // CSSK_EN : Chăm sóc sức khỏe mùa Covid (Tiếng Anh)
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "HDSD",
        dataForm: {
          HDSD_VI: {
            type: undefined, // required, minLength: 1 Mã của cấu hình
            file_id: undefined, // optional Giá trị cấu hình
          },
          HDSD_EN: {
            type: undefined, // required, minLength: 1 Mã của cấu hình
            file_id: undefined, // optional Giá trị cấu hình
          },
          TDSKTN1_VI: {
            type: undefined,
            file_id: undefined,
          },
          TDSKTN1_EN: {
            type: undefined,
            file_id: undefined,
          },
          TDSKTN2_VI: {
            type: undefined,
            file_id: undefined,
          },
          TDSKTN2_EN: {
            type: undefined,
            file_id: undefined,
          },
          QLNNCOVID_VI: {
            type: undefined,
            file_id: undefined,
          },
          QLNNCOVID_EN: {
            type: undefined,
            file_id: undefined,
          },
          DMBN_VI: {
            type: undefined,
            file_id: undefined,
          },
          DMBN_EN: {
            type: undefined,
            file_id: undefined,
          },
          CSSK_VI: {
            type: undefined,
            file_id: undefined,
          },
          CSSK_EN: {
            type: undefined,
            file_id: undefined,
          },
        },
        validForm: {},
        fileUploadOption: {
          HDSD_VI: {
            limit: 1,
            accept: ".pdf",
            fileList: [],
          },
          HDSD_EN: {
            limit: 1,
            accept: ".pdf",
            fileList: [],
          },
          TDSKTN1_VI: {
            limit: 1,
            accept: ".pdf",
            fileList: [],
          },
          TDSKTN1_EN: {
            limit: 1,
            accept: ".pdf",
            fileList: [],
          },
          TDSKTN2_VI: {
            limit: 1,
            accept: ".pdf",
            fileList: [],
          },
          TDSKTN2_EN: {
            limit: 1,
            accept: ".pdf",
            fileList: [],
          },
          QLNNCOVID_VI: {
            limit: 1,
            accept: ".pdf",
            fileList: [],
          },
          QLNNCOVID_EN: {
            limit: 1,
            accept: ".pdf",
            fileList: [],
          },
          DMBN_VI: {
            limit: 1,
            accept: ".pdf",
            fileList: [],
          },
          DMBN_EN: {
            limit: 1,
            accept: ".pdf",
            fileList: [],
          },
          CSSK_VI: {
            limit: 1,
            accept: ".pdf",
            fileList: [],
          },
          CSSK_EN: {
            limit: 1,
            accept: ".pdf",
            fileList: [],
          },
        },
      },
    };
  },
  methods: {
    async fn_initData() {
      try {
        const cauHinhApiRes = await mushroom.user_guide.listAsync();
        if (cauHinhApiRes.result && cauHinhApiRes.result.length > 0) {
          let arrKey = [
            "HDSD_VI",
            "HDSD_EN",
            "TDSKTN1_VI",
            "TDSKTN1_EN",
            "TDSKTN2_VI",
            "TDSKTN2_EN",
            "QLNNCOVID_VI",
            "QLNNCOVID_EN",
            "DMBN_VI",
            "DMBN_EN",
            "CSSK_VI",
            "CSSK_EN",
          ];
          arrKey.forEach(async (element) => {
            let resHDSD_VI = cauHinhApiRes.result.find((item) => {
              return item.type == element;
            });
            if (resHDSD_VI && resHDSD_VI.file_id) {
              let listFile = await mushroom.file.findByIdAsync({
                id: resHDSD_VI.file_id,
              });
              let data = [];
              if (listFile && listFile.result) {
                if (listFile.result.name) {
                  listFile.result.name = decodeURIComponent(
                    listFile.result.name
                  );
                }
                console.log("listFile", listFile.result.name);
                data.push(listFile.result);
              }
              this.mData.dataForm[element] = resHDSD_VI;
              this.mData.fileUploadOption[element].fileList = data;
            }
          });
        }
      } catch (error) {
        console.log("Lỗi load file pdf", error);
      }
    },
    // File

    handleChange(file, fileList, key) {
      console.log("key", key);
      console.log("Vào change", file);
      if (
        file &&
        file.name &&
        file.name.toLowerCase().slice(file.name.length - 3, file.name.length) !=
          "pdf"
      ) {
        window.toastr.info(`Chỉ tải lên file có định dạng PDF`);
        this.mData.fileUploadOption[key].fileList = [];
        return;
      }
      if (
        file &&
        file.size &&
        Math.round(file.size/1000000*10)/10 > 100
      ) {
        window.toastr.info(`Chỉ tải file tối đa 100mb`);
        this.mData.fileUploadOption[key].fileList = [];
        return;
      }
      ExtensionService.upload(file, "HDSD")
        .then(async (res) => {
          console.log("resUpload", res);
          console.log("dataForm", this.mData.dataForm[key]);
          this.mData.dataForm[key].file_id = res.result;
          fileList.forEach((el) => {
            if (el.uid == file.uid) {
              el.id = res.result;
            }
          });
          this.mData.fileUploadOption[key].fileList = fileList;
          console.log(
            "fileListCheck",
            this.mData.fileUploadOption[key].fileList
          );
          let data = this.mData.dataForm[key];
          data.id = this.mData.dataForm[key].id;
          try {
            // await CauHinhApi.update(data);
            if (this.mData.dataForm[key].id) {
              const update_object = {
                id: this.mData.dataForm[key].id, // required
                file_id: res.result,
              };
              await mushroom.user_guide.partialUpdateAsync(update_object);
            } else {
              const create_object = {
                type: key, // required - Loai file
                file_id: res.result, // required, ref: mushroom_file - Ma file
              };
              let resUpload = await mushroom.user_guide.createAsync(
                create_object
              );
              if (resUpload && resUpload.result) {
                this.mData.dataForm[key].id = resUpload.result;
              }
            }
            // this.fn_initData();
            window.toastr.success("Cập nhật file thành công");
          } catch (error) {
            window.toastr.error("Cập nhật file thất bại");
          }
        })
        .catch((error) => {
          console.log("lỗi upload", error);
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    async handlePreview(file) {
      console.log("vào quá Preview", file);
      console.log("ExtensionService.urlFile + file.id",ExtensionService.urlFile + file.id);
      window.open(ExtensionService.urlFile + file.id);
    },
    async handleRemove(key) {
      //debugger;
      console.log("vào remove", key);
      try {
        await mushroom.user_guide.deleteAsync({
          id: this.mData.dataForm[key].id, // required
        });
        this.mData.dataForm[key].file_id = null;
        this.mData.fileUploadOption[key].fileList = [];
        this.mData.dataForm[key].id = null;
        window.toastr.success("Xóa file thành công");
      } catch (error) {
        window.toastr.error("Xóa file thành công");
      }
    },
    handlExceed(key) {
      console.log("vào quá Exceed");
      window.toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption[key].limit} file`
      );
    },

    ///File Tiếng Viet
    // handleChangeHDSD_VI(file, fileList, key) {
    //   debugger;
    //   console.log("key", key);
    //   console.log("Vào change", file, fileList);
    //   if (
    //     file &&
    //     file.name &&
    //     file.name.toLowerCase().slice(file.name.length - 3, file.name.length) !=
    //       "pdf"
    //   ) {
    //     window.toastr.info(`Chỉ tải lên file có định dạng PDF`);
    //     this.mData.fileUploadOption.HDSD_VI.fileList = [];
    //     return;
    //   }
    //   ExtensionService.upload(file, "HDSD")
    //     .then(async (res) => {
    //       console.log("resUpload", res);
    //       this.mData.dataForm.HDSD_VI.file_id = res.result;
    //       fileList.forEach((el) => {
    //         if (el.uid == file.uid) {
    //           el.id = res.result;
    //         }
    //       });
    //       this.mData.fileUploadOption.HDSD_VI.fileList = fileList;
    //       let data = this.mData.dataForm.HDSD_VI;
    //       data.id = this.mData.dataForm.HDSD_VI.id;
    //       try {
    //         // await CauHinhApi.update(data);
    //         this.fn_initData();
    //         window.toastr.success(
    //           "Cập nhật file hướng dẫn sử dụng Tiếng Việt thành công"
    //         );
    //       } catch (error) {
    //         console.log(error);
    //         window.toastr.error(
    //           "Cập nhật file hướng dẫn sử dụng Tiếng Việt thất bại"
    //         );
    //       }
    //     })
    //     .catch(() => {
    //       fileList.forEach((el, i) => {
    //         if (el.uid == file.uid) {
    //           fileList.splice(i, 1);
    //         }
    //       });
    //     });
    // },
    // handlePreviewHDSD_VI(file) {
    //   console.log("vào quá Preview", file);
    //   window.open(ExtensionService.urlFile + file.id);
    // },
    // handleRemoveHDSD_VI() {
    //   console.log("vào remove");
    //   this.mData.dataForm.HDSD_VI.file_id = null;
    //   this.mData.fileUploadOption.HDSD_VI.fileList = [];
    // },
    // handlExceedHDSD_VI() {
    //   console.log("vào quá Exceed");
    //   window.toastr.info(
    //     `Chỉ tải lên tối đa ${this.mData.fileUploadOption.HDSD_VI.limit} file`
    //   );
    // },

    ///File Tiếng ANh
    // handleChangeHDSDTiengAnh(file, fileList){
    //     if(file.name && file.name.toLowerCase().slice(file.name.length - 3,file.name.length) != "pdf"){
    //         window.toastr.info(
    //             `Chỉ tải lên file có định dạng PDF`
    //         );
    //         this.mData.fileUploadOption.HDSDTiengAnh.fileList = [];
    //         return
    //     }
    //     ExtensionService.upload(file, "HDSD")
    //     .then(async res => {
    //         this.mData.dataForm.HDSDTiengAnh.file_id = res.result;
    //         fileList.forEach((el) => {
    //             if (el.uid == file.uid) {
    //             el.id = res.result;
    //             }
    //         });
    //         this.mData.fileUploadOption.HDSDTiengAnh.fileList = fileList;
    //         let data = this.mData.dataForm.HDSDTiengAnh;
    //         data.id = this.mData.dataForm.HDSDTiengAnh.id;
    //         try {
    //             await CauHinhApi.update(data);
    //             this.fn_initData();
    //                 window.toastr.success("Cập nhật file hướng dẫn sử dụng Tiếng Anh thành công");
    //         } catch (error) {
    //             console.log(error);
    //                 window.toastr.error("Cập nhật file hướng dẫn sử dụng Tiếng Anh thất bại");
    //         }
    //     })
    //     .catch(() => {
    //         fileList.forEach((el, i) => {
    //             if (el.uid == file.uid) {
    //             fileList.splice(i, 1);
    //             }
    //         });
    //     });
    // },
    // handlePreviewHDSDTiengAnh(file){
    //     window.open(ExtensionService.urlFile + file.id);
    // },
    // handleRemoveHDSDTiengAnh(){
    //     this.mData.dataForm.HDSDTiengAnh.file_id = null;
    //     this.mData.fileUploadOption.HDSDTiengAnh.fileList = [];
    // },
    // handlExceedHDSDTiengAnh() {
    //     window.toastr.info(
    //         `Chỉ tải lên tối đa ${this.mData.fileUploadOption.HDSDTiengAnh.limit} file`
    //     );
    // },

    // fn_submitForm(type) {
    // this.$refs["myForm"].validate(async valid => {
    //     if (valid) {
    //     if (type == "create") {
    //         await CauHinhApi.create(this.mData.dataForm);
    //         this.fn_resetForm();
    //     }
    //     if (type == "update") {
    //         this.mData.dataForm.id = this.$router.currentRoute.params.id;
    //         await CauHinhApi.update(this.mData.dataForm);
    //         this.fn_go(-1);
    //     }
    //     } else {
    //     MethodService.stopLadda();
    //     return false;
    //     }
    // });
    // },
    // fn_resetForm() {
    // this.$refs["myForm"].resetFields();
    // },
    // fn_go() {
    // this.$router.go(-1);
    // },
    // async fn_getDataById(id) {
    // let res = await CauHinhApi.findById(id);
    // this.mData.dataForm = res.result;
    // },
    // async fn_initDataDefault() {

    // },
  },
  created: function () {
    this.fn_initData();
  },
  mounted: function () {},
};
</script>
<style scoped>
h4 {
  margin-bottom: 0;
}
::v-deep .el-card__header {
  padding: 10px 20px;
}
.d-flex {
  display: flex;
  justify-content: space-between;
}
::v-deep .el-upload-list__item {
  transition: none !important;
}
.drag-file {
  max-width: 430px;
  margin: 0 auto;
}
::v-deep .el-upload-list.el-upload-list--text {
  text-align: left;
}
::v-deep .el-upload__tip {
  font-style: italic;
}
::v-deep .row {
  margin-bottom: 15px !important;
}
</style>